import {
  getCaptchaLocale,
  setPresolvedGeeTest
} from "./chunk-P2B2TNGX.mjs";
import {
  loadScriptOnce
} from "./chunk-JHUVX63K.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/grecaptcha/geetest.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var GEETEST_SCRIPT_ID = "recaptcha_script_gs";
var GEETEST_SCRIPT_URL = "https://static.geetest.com/v4/gt4.js";
var GEETEST_STYLE_ID = "geetest_style";
var UNSOLVED = "Please complete captcha";
var NOT_LOADED = "Error loading GeeTest, please refresh and try again.";
var MISSING_KEY = "No GeeTest v4 key found in config, please follow usage instruction in https://github.com/nadude/webook-frontend/blob/main/packages/api/README.md";
var GEETEST_LANGUAGES = {
  ar: "ara",
  de: "deu",
  en: "eng",
  es: "spa",
  fr: "fra",
  id: "ind",
  ja: "jpn",
  ko: "kor",
  pt: "por",
  ru: "rus",
  zh: "zho"
};
var getGeeTestLanguage = (locale) => GEETEST_LANGUAGES[getLocaleOnly(locale)] || "eng";
var geeTestException = (message, extra) => new Exception({ error: new Error(message), name: "geeTestException", context: { extra } });
var widgetException = (error) => {
  var _a;
  return geeTestException((error == null ? void 0 : error.msg) || "Captcha failed, please try again.", {
    code: error == null ? void 0 : error.code,
    detail: (_a = error == null ? void 0 : error.desc) == null ? void 0 : _a.detail
  });
};
var dismissed = () => new Error(UNSOLVED);
var attempt = null;
var discardGeeTest = () => {
  attempt == null ? void 0 : attempt.reject(dismissed());
  attempt == null ? void 0 : attempt.instance.destroy();
  attempt = null;
};
var loadGeeTestScript = () => __async(null, null, function* () {
  var _a, _b;
  if (!((_b = (_a = ApiConfig.config) == null ? void 0 : _a.grecaptcha) == null ? void 0 : _b.v4GeeTestId)) {
    throw new Error(MISSING_KEY);
  }
  if (typeof window === "undefined" || window.initGeetest4) return;
  yield loadScriptOnce(GEETEST_SCRIPT_ID, GEETEST_SCRIPT_URL);
});
var injectDirectionFix = () => {
  if (document.getElementById(GEETEST_STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = GEETEST_STYLE_ID;
  style.textContent = "[dir='rtl'] .geetest_captcha,[dir='rtl'] .geetest_popup_wrap{direction:ltr}";
  document.head.appendChild(style);
};
var createGeeTest = (config, locale) => __async(null, null, function* () {
  var _a, _b;
  const captchaId = (_b = (_a = ApiConfig.config) == null ? void 0 : _a.grecaptcha) == null ? void 0 : _b.v4GeeTestId;
  if (!captchaId) {
    throw geeTestException(MISSING_KEY);
  }
  try {
    yield loadGeeTestScript();
  } catch (e) {
    throw geeTestException(NOT_LOADED);
  }
  const initGeetest4 = typeof window === "undefined" ? void 0 : window.initGeetest4;
  if (!initGeetest4) {
    throw geeTestException(NOT_LOADED);
  }
  injectDirectionFix();
  return new Promise((resolve, reject) => {
    initGeetest4(
      __spreadProps(__spreadValues({
        captchaId
      }, config), {
        language: getGeeTestLanguage(locale),
        // gt4.js reports a failed resource load only here; without it the callback below never fires
        onError: (error) => reject(widgetException(error))
      }),
      resolve
    );
  });
});
var solveGeeTest = (..._0) => __async(null, [..._0], function* (locale = getCaptchaLocale()) {
  const captcha = yield createGeeTest({ product: "bind", hideSuccess: true }, locale);
  discardGeeTest();
  return new Promise((resolve, reject) => {
    attempt = { instance: captcha, reject };
    captcha.onReady(() => captcha.showCaptcha()).onSuccess(() => {
      const result = captcha.getValidate();
      if (!result) {
        return reject(dismissed());
      }
      resolve(result);
    }).onClose(() => reject(dismissed())).onError((error) => reject(widgetException(error)));
  });
});
var renderGeeTest = (_0, ..._1) => __async(null, [_0, ..._1], function* (element, { locale = getCaptchaLocale(), onError } = {}) {
  const captcha = yield createGeeTest({ product: "popup" }, locale);
  captcha.onSuccess(() => setPresolvedGeeTest(captcha.getValidate() || null)).onError((error) => onError == null ? void 0 : onError(widgetException(error)));
  captcha.appendTo(element);
  return captcha;
});

export {
  GEETEST_SCRIPT_ID,
  GEETEST_SCRIPT_URL,
  discardGeeTest,
  loadGeeTestScript,
  solveGeeTest,
  renderGeeTest
};
//# sourceMappingURL=chunk-G4NYY657.mjs.map